<!--div class="container">
   <div class="tile is-ancestor is-vertical">
      <div class="tile box">Üst sıra</div>
      <div class="tile is-parent">
         

         <div class="tile box is-child is-4">İç sıra</div>
         <div class="tile box is-child is-5">İç sıra 2</div>
         <div class="tile box is-child is-2">İç sıra 3</div>
      </div>
   </div>
</div-->
<div class="container">
   <div class="tile is-ancestor">
      <div class="tile is-parent">
         <article class="tile is-child box">
            <p class="title">One</p>
            <p class="subtitle">Subtitle</p>
         </article>
      </div>
      <div class="tile is-parent">
         <article class="tile is-child box">
            <p class="title">Two</p>
            <p class="subtitle">Subtitle</p>
         </article>
      </div>
      <div class="tile is-parent">
         <article class="tile is-child box">
            <p class="title">Three</p>
            <p class="subtitle">Subtitle</p>
         </article>
      </div>
      <div class="tile is-parent">
         <article class="tile is-child box">
            <p class="title">Four</p>
            <p class="subtitle">Subtitle</p>
         </article>
      </div>
   </div>

   <div class="tile is-ancestor">
      <div class="tile is-vertical is-9">
         <div class="tile">
            <div class="tile is-8 is-parent">
               <article class="tile is-child box">
                  <p>
                     Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolore quos facilis alias consequatur
                     cupiditate officiis iste facere quasi maxime aspernatur, eius magnam recusandae distinctio ipsum
                     quia incidunt pariatur consectetur explicabo odit harum amet voluptates aut? Maxime quis esse
                     reprehenderit quisquam dolores a natus voluptatem temporibus minus blanditiis corporis porro,
                     reiciendis, dicta recusandae eos dignissimos! Ullam accusantium praesentium, maiores quos culpa
                     modi vero molestias facilis ducimus enim nulla sit nostrum incidunt voluptas aperiam accusamus,
                     adipisci, dolores ratione facere distinctio? Impedit quia provident illo labore facilis officiis
                     quas id quos tempora necessitatibus autem alias voluptatem veritatis, ratione sequi eos eligendi
                     rerum reiciendis deleniti numquam cum! Mollitia, pariatur perferendis unde harum autem hic debitis
                     voluptatem architecto sint est repudiandae similique. Optio similique, ea, quod ad et a asperiores
                     id nobis nisi corrupti corporis esse. Dolor perspiciatis aut maiores pariatur laborum ut
                     necessitatibus perferendis unde, aliquam culpa dignissimos eius exercitationem asperiores esse
                     deleniti, quod ab quo. Dolores maiores sint enim assumenda, consectetur ut unde alias magni quod
                     esse porro molestiae excepturi sit placeat quo illum. Ipsam dicta esse nisi eaque iusto doloremque
                     quisquam laudantium saepe neque illum! Accusamus ipsum eaque, nulla provident voluptatibus repellat
                     alias? Possimus nostrum pariatur voluptas debitis eius dolorum cumque quasi.
                  </p>
               </article>
            </div>
            <div class="tile is-parent">
               <article class="tile is-child box">
                  <p class="title">Ten</p>
                  <p class="subtitle">Subtitle</p>
                  <div class="content">
                     <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin ornare magna eros, eu
                        pellentesque tortor vestibulum ut. Maecenas non massa sem. Etiam finibus odio quis feugiat
                        facilisis.
                     </p>
                  </div>
               </article>
            </div>
         </div>
         <div class="tile">
            <div class="tile is-parent">
               <article class="tile is-child box">
                  <p class="title">Five</p>
                  <p class="subtitle">Subtitle</p>
                  <div class="content">
                     <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam semper diam at erat pulvinar, at
                        pulvinar felis blandit. Vestibulum volutpat tellus diam, consequat gravida libero rhoncus ut.
                        Morbi maximus, leo sit amet vehicula eleifend, nunc dui porta orci, quis semper odio felis ut
                        quam.
                     </p>
                  </div>
               </article>
            </div>
            <div class="tile is-8 is-vertical">
               <div class="tile">
                  <div class="tile is-parent">
                     <article class="tile is-child box">
                        <p class="title">Six</p>
                        <p class="subtitle">Subtitle</p>
                     </article>
                  </div>
                  <div class="tile is-parent">
                     <article class="tile is-child box">
                        <p class="title">Seven</p>
                        <p class="subtitle">Subtitle</p>
                     </article>
                  </div>
               </div>
               <div class="tile is-parent">
                  <article class="tile is-child box">
                     <p class="title">Eight</p>
                     <p class="subtitle">Subtitle</p>
                  </article>
               </div>
            </div>
         </div>
      </div>
      <div class="tile is-parent">
         <article class="tile is-child box">
            <div class="content">
               <p class="title">Eleven</p>
               <p class="subtitle">Subtitle</p>
               <div class="content">
                  <p>
                     Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam semper diam at erat pulvinar, at
                     pulvinar felis blandit. Vestibulum volutpat tellus diam, consequat gravida libero rhoncus ut. Morbi
                     maximus, leo sit amet vehicula eleifend, nunc dui porta orci, quis semper odio felis ut quam.
                  </p>
                  <p>
                     Integer sollicitudin, tortor a mattis commodo, velit urna rhoncus erat, vitae congue lectus dolor
                     consequat libero. Donec leo ligula, maximus et pellentesque sed, gravida a metus. Cras ullamcorper
                     a nunc ac porta. Aliquam ut aliquet lacus, quis faucibus libero. Quisque non semper leo.
                  </p>
               </div>
            </div>
         </article>
      </div>
   </div>

   <div class="tile is-ancestor">
      <div class="tile is-parent">
         <article class="tile is-child box">
            <p class="title">Twelve</p>
            <p class="subtitle">Subtitle</p>
            <div class="content">
               <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin ornare magna eros, eu pellentesque
                  tortor vestibulum ut.
               </p>
            </div>
         </article>
      </div>
      <div class="tile is-parent is-6">
         <article class="tile is-child box">
            <p class="title">Thirteen</p>
            <p class="subtitle">Subtitle</p>
            <div class="content">
               <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin ornare magna eros, eu pellentesque
                  tortor vestibulum ut. Maecenas non massa sem. Etiam finibus odio quis feugiat facilisis.
               </p>
            </div>
         </article>
      </div>
      <div class="tile is-parent">
         <article class="tile is-child box">
            <p class="title">Fourteen</p>
            <p class="subtitle">Subtitle</p>
            <div class="content">
               <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin ornare magna eros, eu pellentesque
                  tortor vestibulum ut.
               </p>
            </div>
         </article>
      </div>
   </div>
</div>
